import { connect } from 'react-redux';
//import Hero from './components/hero.js';

const Hero = require('./components/hero');

import { DialogReduxProvider } from './providers/DialogReduxProvider';

const mapStateToHeroProps = (state: any): any => {
    return DialogReduxProvider.mapStateToHeroProps(state);
}

export default connect(mapStateToHeroProps)(Hero.default);